import PortalSetup from './portal-setup';
import { portalSetupReducer } from './portal-setup.reducer';

export {
  PortalSetup,
  portalSetupReducer
};



// WEBPACK FOOTER //
// src/portal-setup/index.js